import { useEffect, useState } from "react";
import { FaAngleUp } from "react-icons/fa";
import "./ScrollToTopButton.css";

export default function ScrollToTopButton({ target = window, threshold = 200 }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el =
      typeof target === "string" ? document.querySelector(target) : target;
    if (!el) return;
    const onScroll = () => {
      const y = el === window ? window.scrollY : el.scrollTop;
      setVisible(y > threshold);
    };
    el.addEventListener("scroll", onScroll, { passive: true });
    return () => el.removeEventListener("scroll", onScroll);
  }, [target, threshold]);

  if (!visible) return null;

  const scrollToTop = () => {
    const el =
      typeof target === "string" ? document.querySelector(target) : target;
    (el === window ? window : el).scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      aria-label="Subir arriba"
      onClick={scrollToTop}
      className="scroll-up-btn"
    >
      <FaAngleUp className="relative z-10 text-xl" />
    </button>
  );
}
